/**
 * bbs接口统一管理
 */
import {del, get, patch, post, put} from './http'

/**
 * 获取资讯列表
 * @param params
 */
export const getConsultList = (params) => get('goodsmanual/sale/consult/ent/list', params)

/**
 * 添加咨询
 * @param params
 * http://yapi.laodao.so/project/640/interface/api/52416
 */
export const addConsult = (params) => post('goodsmanual/sale/consult', params)

/**
 * 获取详情
 * @param id
 */
export const getConsultDetail = (id) => get('goodsmanual/sale/consult/ent/' + id, {})

/**
 * 编辑保存
 * @param id
 * @param params
 */
export const editConsultDetail = (id, params) => patch('goodsmanual/sale/consult/' + id, params)

/**
 * 编辑保存
 * @param id
 * @param params
 */
export const delConsult = (params) => del('goodsmanual/sale/consult/list', params)
